const nullify = <T>(nullFunction: (nullFunction: T | undefined) => void) => {
  return (arg: T | null) => nullFunction(arg ?? undefined);
};

export default nullify;
